import { usePairOffers } from 'src/common/apollo/hooks/usePairOffers'
import { AnyToken } from 'src/common/types/models/Tokens'
import { useActiveAccount } from 'thirdweb/react'
import { getMarketDepthData } from './utils'
import usePairMarketPrice from 'src/common/apollo/hooks/usePairMarketPrice'

const useMarketDepthData = (sellToken: AnyToken, buyToken: AnyToken) => {
  const account = useActiveAccount()

  const { pricePerB, loading: pairMarketPriceLoading } = usePairMarketPrice(
    sellToken,
    buyToken
  )

  const { offers, loading: pairOffersLoading } = usePairOffers({
    sellToken,
    buyToken,
    accountAddress: account?.address,
  })

  const data = getMarketDepthData(offers, pricePerB)

  return {
    data,
    marketPrice: pricePerB,
    loading: pairMarketPriceLoading || pairOffersLoading,
  }
}

export default useMarketDepthData
